import axios from "axios";
import imageCompression from "browser-image-compression";
import { logger } from "@/lib/logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });
export { http };

// Public
export const fetchAnnonces = (params) =>
  http.get("/annonces", { params }).then((r) => r.data);
export const fetchAnnonce = (id) =>
  http.get(`/annonces/${id}`).then((r) => r.data);
export const fetchSimilar = (id) =>
  http.get(`/annonces/${id}/similar`).then((r) => r.data);
export const createAnnonce = (data) =>
  http.post("/annonces", data).then((r) => r.data);

export const fetchHotels = (params) =>
  http.get("/hotels", { params }).then((r) => r.data);
export const fetchHotel = (id) =>
  http.get(`/hotels/${id}`).then((r) => r.data);
export const updateHotelManager = (hotelId, payload) =>
  http.patch(`/hotels/${hotelId}/manager`, payload).then((r) => r.data);
export const sendTarifExpressLink = (hotelId) =>
  http.post(`/hotels/${hotelId}/tarif-express/send`).then((r) => r.data);
export const fetchTarifExpressHistory = (hotelId) =>
  http.get(`/hotels/${hotelId}/tarif-express/history`).then((r) => r.data);
export const fetchTarifExpress = (token) =>
  http.get(`/tarif-express/${token}`).then((r) => r.data);
export const applyTarifExpress = (token, payload) =>
  http.post(`/tarif-express/${token}`, payload).then((r) => r.data);
export const fetchHotelStats = (hotelId, days = 7) =>
  http.get(`/hotels/${hotelId}/stats`, { params: { days } }).then((r) => r.data);
export const fetchBookingPolicy = () => http.get("/hotels/booking-policy").then((r) => r.data);
export const fetchReservation = (ref) => http.get(`/hotels/reservations/${ref}`).then((r) => r.data);
export const verifyReservationPayment = (ref) => http.post(`/hotels/reservations/${ref}/verify`).then((r) => r.data);
export const cancelReservation = (ref, phone) => http.post(`/hotels/reservations/${ref}/cancel`, { phone }).then((r) => r.data);
export const payReservationDeposit = (ref) => http.post(`/hotels/reservations/${ref}/pay`).then((r) => r.data);
export const searchDayUse = (params) => http.get("/hotels-par-heure", { params }).then((r) => r.data);
export const createDayUseReservation = (hotelId, payload) => http.post(`/hotels/${hotelId}/reservations-heure`, payload).then((r) => r.data);
export const updateDayUseOffer = (hotelId, payload) => http.patch(`/hotels/${hotelId}/offre-par-heure`, payload).then((r) => r.data);
export const inviteDayUse = (hotelId) => http.post(`/hotels/${hotelId}/offre-par-heure/inviter`).then((r) => r.data);
export const requestWhatsappPayment = (payload) => http.post("/payments/whatsapp-request", payload).then((r) => r.data);
export const fetchReviewInfo = (token) => http.get(`/avis/${token}`).then((r) => r.data);
export const submitReview = (token, payload) => http.post(`/avis/${token}`, payload).then((r) => r.data);
export const fetchHotelReviews = (hotelId) => http.get(`/hotels/${hotelId}/reviews`).then((r) => r.data);
export const replyHotelReview = (hotelId, reviewId, reply) => http.post(`/hotels/${hotelId}/reviews/${reviewId}/reply`, { reply }).then((r) => r.data);
export const fetchTarifExpressConfig = () =>
  http.get("/tarif-express-config").then((r) => r.data);
export const fetchHotelProStatus = (hotelId) =>
  http.get(`/hotels/${hotelId}/pro-status`).then((r) => r.data);
export const startHotelProSubscription = (hotelId, phone) =>
  http.post("/subscriptions/hotel-pro/start", { hotel_id: hotelId, phone }).then((r) => r.data);
export const startEnchereCampaign = (hotelId, payload) =>
  http.post(`/hotels/${hotelId}/encheres/start`, payload).then((r) => r.data);
export const fetchEnchereReport = (hotelId) => http.get(`/hotels/${hotelId}/encheres/rapport`).then((r) => r.data);
export const toggleEncherePause = (hotelId) => http.post(`/hotels/${hotelId}/encheres/pause`).then((r) => r.data);
export const recordSponsoredClick = (campaignId) => http.post(`/encheres/${campaignId}/click`).catch(() => {});
export const fetchEscrowEligibility = (annonceId) => http.get(`/escrow/eligibility/${annonceId}`).then((r) => r.data);
export const startEscrow = (payload) => http.post("/escrow/start", payload).then((r) => r.data);
export const fetchEscrow = (ref) => http.get(`/escrow/${ref}`).then((r) => r.data);
export const verifyEscrow = (ref) => http.post(`/escrow/${ref}/verify`).then((r) => r.data);
export const escrowAction = (ref, action, body = {}) => http.post(`/escrow/${ref}/${action}`, body).then((r) => r.data);
export const fetchMyEscrows = () => http.get("/me/escrows").then((r) => r.data);
export const fetchAdminEscrows = (status) => http.get("/admin/escrows", { params: status ? { status } : {} }).then((r) => r.data);
export const adminEscrowAction = (ref, action, body = {}) => http.post(`/admin/escrows/${ref}/${action}`, body).then((r) => r.data);
export const fetchOffreLancementStatus = () => http.get("/hotelleries/offre-lancement/status").then((r) => r.data);
export const inscrireOffreLancement = (payload) => http.post("/hotelleries/offre-lancement/inscrire", payload).then((r) => r.data);
export const approveHotel = (hotelId) => http.post(`/admin/hotels/${hotelId}/approve`).then((r) => r.data);

export const fetchStats = () => http.get("/stats").then((r) => r.data);
export const fetchStatsByCountry = () => http.get("/stats/by-country").then((r) => r.data);
export const fetchStatsByCategory = (country) =>
  http.get("/stats/by-category", { params: country ? { country } : {} }).then((r) => r.data);
export const fetchLatestAnnonce = (country, withinHours = 24) =>
  http.get(`/annonces/latest?country=${country}&within_hours=${withinHours}`)
      .then((r) => (r.status === 204 ? null : r.data))
      .catch(() => null);

// Annonce views, compare, seller profile
export const incrementView = (id) =>
  http.post(`/annonces/${id}/view`).then((r) => r.data);
export const fetchCompareAnnonces = (ids) =>
  http.get("/compare-annonces", { params: { ids: ids.join(",") } }).then((r) => r.data);
export const fetchSellerProfile = (userId) =>
  http.get(`/sellers/${userId}`).then((r) => r.data);
export const fetchSellerAnnonces = (userId) =>
  http.get(`/sellers/${userId}/annonces`).then((r) => r.data);

// Email Alerts
export const createEmailAlert = (payload) =>
  http.post("/me/email-alerts", payload).then((r) => r.data);
export const listMyEmailAlerts = () =>
  http.get("/me/email-alerts").then((r) => r.data);
export const deleteEmailAlert = (id) =>
  http.delete(`/me/email-alerts/${id}`).then((r) => r.data);

export const submitContact = (data) =>
  http.post("/contact", data).then((r) => r.data);
export const fetchAdminContactRequests = () =>
  http.get("/admin/contact-requests").then((r) => r.data);

// Admin annonces
export const fetchAdminMe = () => http.get("/admin/me").then((r) => r.data);
export const fetchInvestments = () => http.get("/admin/investments").then((r) => r.data);
export const addInvestment = (payload) => http.post("/admin/investments", payload).then((r) => r.data);
export const deleteInvestment = (id) => http.delete(`/admin/investments/${id}`).then((r) => r.data);
export const exportInvestmentsCsv = () => http.get("/admin/investments/export", { responseType: "blob" }).then((r) => r.data);
export const addInvestmentPhase = (payload) => http.post("/admin/investments/phases", payload).then((r) => r.data);
export const toggleInvestmentPhase = (id, completed) => http.patch(`/admin/investments/phases/${id}`, { completed }).then((r) => r.data);
export const deleteInvestmentPhase = (id) => http.delete(`/admin/investments/phases/${id}`).then((r) => r.data);
export const fetchBiometricStatus = () => http.get("/me/biometric/status").then((r) => r.data);
export const disableBiometric = () => http.delete("/me/biometric").then((r) => r.data);
export const fetchPaymentAccounts = () => http.get("/me/payment-accounts").then((r) => r.data);
export const addPaymentAccount = (payload) => http.post("/me/payment-accounts", payload).then((r) => r.data);
export const deletePaymentAccount = (id) => http.delete(`/me/payment-accounts/${id}`).then((r) => r.data);
export const uploadBiometricSelfie = (payload) => http.post("/me/biometric/selfie", payload).then((r) => r.data);
export const fetchAdminSelfies = (limit = 60) => http.get("/admin/biometric/selfies", { params: { limit } }).then((r) => r.data);
export const fetchCampagnes = () => http.get("/admin/campagnes").then((r) => r.data);
export const submitGuideFeedback = (data) => http.post("/guide-feedback", data).then((r) => r.data);
export const fetchGuideFeedbackStats = () => http.get("/admin/guide-feedback/stats").then((r) => r.data);
export const guideFeedbackExportUrl = `${API}/admin/guide-feedback/export`;
export const fetchFinancingLeads = (status) => http.get("/admin/financing-leads", { params: status ? { status } : {} }).then((r) => r.data);
export const fetchCinetpayStatus = () => http.get("/admin/cinetpay/status").then((r) => r.data);
export const fetchAdminPayments = (status) => http.get("/admin/payments", { params: status ? { status } : {} }).then((r) => r.data);
export const fetchAdminRefunds = (status = "a_traiter") => http.get("/admin/refunds", { params: { status } }).then((r) => r.data);
export const markRefundDone = (ref, note = "") => http.post(`/admin/refunds/${ref}/done`, { note }).then((r) => r.data);
export const revokeProSubscription = (email) => http.post("/admin/subscriptions/revoke", { email }).then((r) => r.data);
export const fetchSmsStatus = () => http.get("/admin/sms/status").then((r) => r.data);
export const fetchEmailStatus = () => http.get("/admin/email/status").then((r) => r.data);
export const fetchAtLog = (limit = 50) => http.get("/admin/sms/at-log", { params: { limit } }).then((r) => r.data);
export const runProNudge = () => http.post("/admin/pro-nudge/run").then((r) => r.data);
export const runEquipementsNudge = () => http.post("/admin/equipements-nudge/run").then((r) => r.data);
export const pingPresence = () => http.post("/presence/ping").then((r) => r.data);
export const fetchPresence = (userId) => http.get(`/presence/${userId}`).then((r) => r.data);
export const fetchAdminStats = () => http.get("/admin/stats").then((r) => r.data);
export const fetchAdminOtpStats = () => http.get("/admin/otp-stats").then((r) => r.data);
export const fetchAdminAuthLog = ({ event = "", failed_only = false, limit = 200 } = {}) =>
  http.get("/admin/security/auth-log", { params: { event, failed_only, limit } }).then((r) => r.data);
export const fetchHealthDeep = () => http.get("/health/deep").then((r) => r.data);

// Fodindin Pro subscription (CinetPay)
export const fetchMySubscription = () => http.get("/me/subscription").then((r) => r.data);
export const fetchMyFidelite = () => http.get("/fidelite/me").then((r) => r.data);
export const startProSubscription = (phone, extra = {}) =>
  http.post("/subscriptions/pro/start", { phone, ...extra }).then((r) => r.data);
export const verifyProSubscription = (transactionId) =>
  http.post("/subscriptions/pro/verify", transactionId ? { transaction_id: transactionId } : {}).then((r) => r.data);
export const chooseFreePlan = () => http.post("/me/plan", { plan: "free" }).then((r) => r.data);
export const fetchMyOnboarding = () => http.get("/me/onboarding").then((r) => r.data);

// AI Pro features
export const aiBoostTitle = (body) => http.post("/ai/boost-title", body).then((r) => r.data);
export const aiBoostDescription = (body) => http.post("/ai/boost-description", body).then((r) => r.data);
export const aiPriceCoach = (body) => http.post("/ai/price-coach", body).then((r) => r.data);
// Admin
export const fetchAdminProRevenue = () => http.get("/admin/pro-revenue").then((r) => r.data);
export const fetchAdminAnnonces = (q) =>
  http.get("/admin/annonces", { params: q ? { q } : {} }).then((r) => r.data);
export const updateAdminAnnonce = (id, patch) =>
  http.patch(`/admin/annonces/${id}`, patch).then((r) => r.data);
export const deleteAdminAnnonce = (id) =>
  http.delete(`/admin/annonces/${id}`).then((r) => r.data);
export const bulkAdminAnnonces = (ids, action, patch) =>
  http.post("/admin/annonces/bulk", { ids, action, patch }).then((r) => r.data);
export const exportAdminAnnoncesUrl = (filters = {}) => {
  const qs = new URLSearchParams(
    Object.entries(filters).filter(([, v]) => v !== "" && v !== undefined && v !== null && v !== false)
  ).toString();
  return `${API}/admin/annonces/export${qs ? `?${qs}` : ""}`;
};

// Hotel availability
export const fetchHotelAvailability = (hotelId, date) =>
  http.get(`/hotels/${hotelId}/availability`, { params: date ? { date } : {} }).then((r) => r.data);
export const createHotelReservation = (hotelId, payload) =>
  http.post(`/hotels/${hotelId}/reservations`, payload).then((r) => r.data);
export const fetchAvailableHotels = ({ date, start_hour, end_hour }) =>
  http.get("/hotels-disponibles", { params: { date, start_hour, end_hour } }).then((r) => r.data);
export const fetchHotelReservations = (hotelId) =>
  http.get(`/hotels/${hotelId}/reservations`).then((r) => r.data);
export const toggleAutoBump = (annonceId, enabled) =>
  http.post(`/me/annonces/${annonceId}/auto-bump`, { enabled }).then((r) => r.data);
export const fetchProStats = () => http.get("/me/pro-stats").then((r) => r.data);
export const translateAnnonce = (annonceId) =>
  http.post("/ai/translate-annonce", { annonce_id: annonceId }).then((r) => r.data);
export const setMultiCountry = (annonceId, countries) =>
  http.post(`/me/annonces/${annonceId}/multi-country`, { countries }).then((r) => r.data);
export const fetchDisponibilites = (annonceId) =>
  http.get(`/annonces/${annonceId}/disponibilites`).then((r) => r.data);
export const saveDisponibilites = (annonceId, blocked_dates) =>
  http.put(`/me/annonces/${annonceId}/disponibilites`, { blocked_dates }).then((r) => r.data);
export const updateHotelAvailability = (hotelId, date, slots) =>
  http.put(`/hotels/${hotelId}/availability`, { date, slots }).then((r) => r.data);
export const updateHotelConfig = (hotelId, config) =>
  http.patch(`/hotels/${hotelId}/config`, config).then((r) => r.data);
export const fetchManagedHotels = () =>
  http.get("/me/managed-hotels").then((r) => r.data);

// Cloudinary
export const fetchCloudinarySignature = () =>
  http.post("/uploads/cloudinary/signature").then((r) => r.data);

export const uploadToCloudinary = async (file) => {
  // Compress images before upload: max 1.5 MB, max 1600px, JPEG 0.82.
  // Skips already-small images and non-bitmap formats (SVG/GIF kept as-is).
  let fileToUpload = file;
  const isBitmap = /^image\/(jpeg|jpg|png|webp|heic|heif)$/i.test(file.type);
  const needsCompression = isBitmap && file.size > 600 * 1024; // > 600 KB
  if (needsCompression) {
    try {
      fileToUpload = await imageCompression(file, {
        maxSizeMB: 1.5,
        maxWidthOrHeight: 1600,
        useWebWorker: true,
        initialQuality: 0.82,
        fileType: "image/jpeg",
      });
    } catch (e) {
      // Fall back to original file if compression fails
      logger.warn("Image compression failed, uploading original:", e?.message);
      fileToUpload = file;
    }
  }

  // signature endpoint requires our backend auth (401 here = expired session)
  const sig = await fetchCloudinarySignature();
  const fd = new FormData();
  fd.append("file", fileToUpload);
  fd.append("api_key", sig.api_key);
  fd.append("timestamp", sig.timestamp);
  fd.append("signature", sig.signature);
  fd.append("folder", sig.folder);
  const res = await fetch(`https://api.cloudinary.com/v1_1/${sig.cloud_name}/auto/upload`, { method: "POST", body: fd });
  if (!res.ok) {
    const err = new Error(`Cloudinary upload failed: ${res.status}`);
    err.status = res.status;
    err.source = "cloudinary";
    throw err;
  }
  const data = await res.json();
  return data.secure_url;
};

// Yango Delivery
export const fetchYangoConfig = () =>
  http.get("/delivery/yango/config").then((r) => r.data);
export const requestYangoQuote = (data) =>
  http.post("/delivery/yango/quote", data).then((r) => r.data);

// Auth-scoped
export const fetchMyAnnonces = () =>
  http.get("/me/annonces").then((r) => r.data);
// Posts a message to the active Service Worker so it can purge any cached
// copy of the given annonce (by id and/or ref). Safe to call even when no SW
// is registered.
function _invalidateAnnonceCache(...ids) {
  if (typeof navigator === "undefined" || !navigator.serviceWorker) return;
  navigator.serviceWorker.ready
    .then((reg) => {
      const target = reg.active || reg.installing || reg.waiting;
      if (!target) return;
      for (const id of ids) {
        if (id) target.postMessage({ type: "invalidate-annonce", id: String(id) });
      }
    })
    .catch(() => { /* SW unavailable — ignore */ });
}

export const updateMyAnnonce = (id, data) =>
  http.patch(`/me/annonces/${id}`, data).then((r) => {
    _invalidateAnnonceCache(r.data?.id, r.data?.ref);
    return r.data;
  });
export const deleteMyAnnonce = (id) =>
  http.delete(`/me/annonces/${id}`).then((r) => {
    _invalidateAnnonceCache(id, r.data?.deleted);
    return r.data;
  });
export const fetchMyFavorites = () =>
  http.get("/me/favorites").then((r) => r.data);
export const toggleFavoriteRemote = (annonceId) =>
  http.post(`/me/favorites/${annonceId}`).then((r) => r.data);
export const updateProfile = (data) =>
  http.patch("/me/profile", data).then((r) => r.data);

export const fetchConversations = () =>
  http.get("/me/conversations").then((r) => r.data);
export const startConversation = (data) =>
  http.post("/me/conversations", data).then((r) => r.data);
export const fetchMessages = (convId) =>
  http.get(`/me/conversations/${convId}/messages`).then((r) => r.data);
export const sendMessage = (convId, text) =>
  http.post(`/me/conversations/${convId}/messages`, { text }).then((r) => r.data);
export const pingTyping = (convId) =>
  http.post(`/me/conversations/${convId}/typing`).then((r) => r.data);
export const fetchUnreadCount = () =>
  http.get("/me/unread-count").then((r) => r.data);

export const fetchBoostOptions = () => http.get("/boost/options").then((r) => r.data);
export const startBoost = (annonceId, payload) => http.post(`/annonces/${annonceId}/boost/start`, payload).then((r) => r.data);
export const fetchHotelChambres = (hotelId) => http.get(`/hotels/${hotelId}/chambres`).then((r) => r.data);
export const saveHotelChambres = (hotelId, chambres) => http.put(`/hotels/${hotelId}/chambres`, chambres).then((r) => r.data);
export const trackContactClick = (annonceId) => http.post(`/annonces/${annonceId}/contact-click`).catch(() => {});
export const fetchBoostStats = (annonceId) => http.get(`/annonces/${annonceId}/boost/stats`).then((r) => r.data);
export const markAnnonceSold = (id) => http.post(`/me/annonces/${id}/vendu`).then((r) => r.data);
export const submitSalesSurvey = (id, payload) => http.post(`/me/annonces/${id}/vendu/questionnaire`, payload).then((r) => r.data);
export const fetchAdminSalesSurveys = () => http.get("/admin/sales-surveys").then((r) => r.data);
